import AddPersonDialog from "@/components/Forms/SubForms/AddPersonDialog.tsx";
import MrtPeopleTable from "@/components/Table/MrtPeopleTable.tsx";
import { Stack, Typography } from "@mui/material";
import { type ReactNode, useEffect } from "react";
import { Outlet } from "react-router-dom";

const PeoplePage = (): ReactNode => {
    useEffect(() => {
        document.title = "People";
    }, []);

    return (
        <>
            <Stack
                sx={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                }}
            >
                <Typography variant="h4" mb={2}>
                    People
                </Typography>
                <AddPersonDialog />
            </Stack>

            <MrtPeopleTable />
            <Outlet />
        </>
    );
};

export default PeoplePage;
